<template>
    <tr class="setItems__item setItems__item--shrinked mb-3 mb-md-1">
        <td>
            <product-counter @input="setQuanitity" v-model="item.quantity" :allowZero="true"></product-counter>
            <confirm-delete-popup @confirm="submit" @cancel="closePopup" :show="showConfirmPopup"></confirm-delete-popup>
        </td>
        <td class="setItems__title ml-md-3">{{name}}</td>

        <template v-if="hasCustomTechnicalParameters">
            <td v-bind:customTechnicalParameter="customTechnicalParameter" v-for="customTechnicalParameter in customTechnicalParameters" class="ml-2 text-nowrap">
                {{ getTechnicalParameterValue(customTechnicalParameter) }}
            </td>
        </template>
        <template v-else>
            <td v-bind:technicalParameter="technicalParameter" v-for="technicalParameter in technicalParameters" class="ml-2 text-nowrap">
                 {{ getTechnicalParameterValue(technicalParameter) }}
            </td>
        </template>

        <td v-for="index in getRemainingColumnsCount()" :key="index">&nbsp;</td>
        <td class="ml-4 text-nowrap setItems__price">
            {{ $nf(price, 'currency' + currencyCode, 'cs-CZ') }}
        </td>
    </tr>
</template>
<script>
    export default {
        data: function () {
            return {
                showConfirmPopup: false
            };
        },
        props: ['item'],
        computed: {
            name: function () {
                return this.item.variantInfo.name;
            },
            hasCustomTechnicalParameters: function () {
                return this.item.isCustom;
            },
            customTechnicalParameters: function() { // convert custom technical parameters unified format
                var _this = this;
                let params = [
                    {
                        type: 'size',
                        value: this.$t('common.customDimension'),
                    }
                ];
                this.item.customParameters.forEach(function(item) {
                    switch( item.type ) {
                        case 'type-dimensions':
                            params.push({
                                type: 'dimensions',
                                value: item.value.width + ' × ' + item.value.length + ' '+ _this.$t('store.getters.cm')
                            });
                            break;
                        case 'oxford':
                            params.push({
                                type: 'oxford-style',
                                value: item.value.isOxford ? _this.$t('common.oxfordStyle') : ''
                            });
                            break;
                    }
                });
                return params;
            },
            technicalParameters: function () {
                var _this = this;
                let params = [];
                this.item.variantInfo.technicalParameters.forEach(function(technicalParameter) {
                    var tp = _this.$store.getters.convertTechnicalParameter(technicalParameter);
                    params.push(tp);
                });
                return params;
            },
            price: function() {
                return this.item.variantInfo.price.priceWithVat * this.item.quantity;
            },
            currency: function() {
                return this.item.variantInfo.price.currency.htmlString;
            },
            currencyCode: function() {
                return this.item.variantInfo.price.currency.code;
            }
        },
        methods: {
            setQuanitity: function (value) {
                if(value <= 0) {
                    this.openPopup();
                } else {
                    this.$store.dispatch('changeProductQuantity', {
                        uid: this.item.uid,
                        quantity: value
                    });
                }
            },
            getTechnicalParameterValue: function(tp) {
                return tp.value;
            },
            openPopup() {
                this.showConfirmPopup = true;
            },
            submit() {
                this.showConfirmPopup = false;
                this.$store.dispatch('removeItem', {uid: this.item.uid});
            },
            closePopup() {
                this.showConfirmPopup = false;
                this.item.quantity = 1;
            },
            getRemainingColumnsCount: function() {
                var tpNum = 0;
                if( this.hasCustomTechnicalParameters ) {
                    tpNum = this.customTechnicalParameters.length;
                } else {
                    tpNum = this.technicalParameters.length;
                }
                let result = 4 - tpNum;
                if(result < 0) {
                   result = 0;
                }
                return result;
            }
        }
    }
</script>
